export const GET_ROOF_LIST = '/building/GET_ROOF_LIST';
export const GET_FLOORING_LIST = '/building/GET_FLOORING_LIST';
export const GET_WALLS_AND_PARTITION_LIST = '/building/GET_WALLS_AND_PARTITION_LIST';
export const SHOW_DATA = '/building/show_data';
export const UPDATE_DATA = '/building/update_data';
export const GET_BUILDING_MATERIAL_TYPE = '/setting/building_material_type';
export const GET_FLOOR_LIST = '/building/get_floor_list';
export const GET_SINGLE_BUILDING_MATERIAL_TYPE = '/settings/get_single_material_type';
export const GET_SINGLE_BUILDING_MATERIAL = 'settings/get_single_building_material';


export const FORM_DATA = {
  name: '',
  description: '',
  is_active: false,
};

export const LAND_PROPERTY_ASSESSMENT_FORM_DATA = {
  rptax_land_classification_id: '',
};